import React, { Fragment } from "react";
import Consultation from "../../component/Other/Consultation";
import Footer from "../../component/Other/Footer";
import Navbar from "./../../component/Navbar/Navbar";
const Price = (props) => {
  return (
    <Fragment>
      <div className="overflow-hidden position-relative">
        <div className="position-relative">
          <img
            src="./../images/new/dsad.png"
            className="images__bg-head"
            alt=""
          />
          <div className="position-relative z-2">
            <Navbar />
            <section>
              <div className="container">
                <div className="text-center">
                  <h2 className="font__size--64 text__65-1024 text__65-sm text__65-xxs yeseva fw-normal">
                    Pricing Plan
                  </h2>
                  <p className="medium font__size--14 text__14-1024 lh-2 color__gray-1">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. A
                    amet vitae vel id id porttitor ut in.{" "}
                    <br className="d-none d-md-block" /> Integer pretium egestas
                    nisi, nunc, purus sit vitae nisi, etiam.{" "}
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>

        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-6 mb-4 mb-lg-0 col-lg-4">
                <div className="wrapper__price-plan">
                  <div className="text-center">
                    <h5 className="normal font__size--20 text__20-1024 yeseva">
                      BASIC
                    </h5>
                    <p className="bold font__size--24 text__24-1024 color__green mb-4">
                      $32
                    </p>
                    <p className="medium font__size--14 text__14-1024 mb-4 medium">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. A
                      amet vitae vel id id porttitor ut in.{" "}
                    </p>
                  </div>
                  <div className="d-flex align-items-center mb-4">
                    <img src="./../images/new/Group 24030.svg" alt="" />
                    <span className="medium font__size--14 text__14-1024 lh-2 color__gray-1 mx-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-4">
                    <img src="./../images/new/Group 24030.svg" alt="" />
                    <span className="medium font__size--14 text__14-1024 lh-2 color__gray-1 mx-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <img src="./../images/new/Group 24030.svg" alt="" />
                    <span className="medium font__size--14 text__14-1024 lh-2 color__gray-1 mx-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </span>
                  </div>

                  <div className="mt-5 text-center">
                    <a
                      href="#!"
                      className="medium font__size--14 text__14-1024 color__green btn btn__outlined--green shadow no__opacity"
                    >
                      Pick Package
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-4 mb-lg-0 col-lg-4">
                <div className="wrapper__price-plan">
                  <div className="text-center">
                    <h5 className="normal font__size--20 text__20-1024 yeseva">
                      MEDIUM
                    </h5>
                    <p className="bold font__size--24 text__24-1024 color__green mb-4">
                      $60
                    </p>
                    <p className="medium font__size--14 text__14-1024 mb-4 medium">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. A
                      amet vitae vel id id porttitor ut in.{" "}
                    </p>
                  </div>
                  <div className="d-flex align-items-center mb-4">
                    <img src="./../images/new/Group 24030.svg" alt="" />
                    <span className="medium font__size--14 text__14-1024 lh-2 color__gray-1 mx-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-4">
                    <img src="./../images/new/Group 24030.svg" alt="" />
                    <span className="medium font__size--14 text__14-1024 lh-2 color__gray-1 mx-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-4">
                    <img src="./../images/new/Group 24030.svg" alt="" />
                    <span className="medium font__size--14 text__14-1024 lh-2 color__gray-1 mx-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <img src="./../images/new/Group 24030.svg" alt="" />
                    <span className="medium font__size--14 text__14-1024 lh-2 color__gray-1 mx-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </span>
                  </div>

                  <div className="mt-5 text-center">
                    <a
                      href="#!"
                      className="medium font__size--14 text__14-1024 color__green btn btn__outlined--green shadow no__opacity"
                    >
                      Pick Package
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-4 mb-lg-0 col-lg-4">
                <div className="wrapper__price-plan">
                  <div className="text-center">
                    <h5 className="normal font__size--20 text__20-1024 yeseva">
                      PREMIUM
                    </h5>
                    <p className="bold font__size--24 text__24-1024 color__green mb-4">
                      $100
                    </p>
                    <p className="medium font__size--14 text__14-1024 mb-4 medium">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. A
                      amet vitae vel id id porttitor ut in.{" "}
                    </p>
                  </div>
                  <div className="d-flex align-items-center mb-4">
                    <img src="./../images/new/Group 24030.svg" alt="" />
                    <span className="medium font__size--14 text__14-1024 lh-2 color__gray-1 mx-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-4">
                    <img src="./../images/new/Group 24030.svg" alt="" />
                    <span className="medium font__size--14 text__14-1024 lh-2 color__gray-1 mx-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-4">
                    <img src="./../images/new/Group 24030.svg" alt="" />
                    <span className="medium font__size--14 text__14-1024 lh-2 color__gray-1 mx-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-4">
                    <img src="./../images/new/Group 24030.svg" alt="" />
                    <span className="medium font__size--14 text__14-1024 lh-2 color__gray-1 mx-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <img src="./../images/new/Group 24030.svg" alt="" />
                    <span className="medium font__size--14 text__14-1024 lh-2 color__gray-1 mx-2">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    </span>
                  </div>

                  <div className="mt-5 text-center">
                    <a
                      href="#!"
                      className="medium font__size--14 text__14-1024 color__green btn btn__outlined--green shadow no__opacity"
                    >
                      Pick Package
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Consultation />

        <Footer />
      </div>
    </Fragment>
  );
};

export default Price;
